module.exports = __webpack_public_path__ + "images/emoji/trollface.93f9726f88efd7f6f847.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/trollface.png
// module id = 0UBM
// module chunks = 2